import { Tag } from "@seneca/senekit";

export default function PremiumTag() {
  return (
    <Tag tone="premium" strength="weak" size="xsmall">
      Premium
    </Tag>
  );
}
